import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { saveProduct } from 'redux/product'
import ProductEdit from './ProductEdit'

const mapStateToProps = (state, ownProps) => {
  const { product } = state.product
  return { product }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveProduct,
    },
    dispatch
  )
}

class Product extends React.Component {
  render() {
    // props
    const { product, saveProduct } = this.props // redux
    const {
      match: {
        params: { article_number },
      },
    } = this.props // router
    return !article_number ? (
      <div className="inactive-window">
        <ComponentPlaceholder loading={false} />
      </div>
    ) : (
      <ProductEdit
        product={product}
        onSave={saveProduct}
        form={'product_edit_form'}
        tabs={[
          'generic',
          'media',
          'properties',
          'accessories',
          'todos',
          'logs',
          'specialitems'
        ]}
      />
    )
  }
}

Product = connect(mapStateToProps, mapDispatchToProps)(Product)
export default withRouter(Product)



// WEBPACK FOOTER //
// ./src/components/admin/Products/Product.jsx